
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              <strong>Starlight Motors</strong>
            </h4>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Melbourne's premier mobile car detailing service. We bring showroom quality 
              results directly to your location with professional equipment and premium products.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/starlightmotors_/" 
                target="_blank" 
                rel="nofollow"
                className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="https://www.facebook.com/572777975922525/" 
                target="_blank" 
                rel="nofollow"
                className="w-10 h-10 bg-blue-600 rounded-full flex items.center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="font-semibold mb-4">
              <strong>Services</strong>
            </h5>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#services" className="hover:text-white transition-colors">Full Detail - $250</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Maintenance - $170</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Ceramic Coating</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Headliner Installation</a></li>
            </ul>
          </div>

          <div>
            <h5 className="font-semibold mb-4">
              <strong>Contact</strong>
            </h5>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:0491121950" className="hover:text-white transition-colors">
                  0491 121 950
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                Melbourne, VIC
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                Mon-Sat: 7AM-6PM
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2025 Starlight Motors Mobile Detailing. All rights reserved. | ABN: 12 345 678 901
          </div>
          <div className="text-gray-400 text-sm mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="nofollow"
              className="hover:text-white transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
